import React, { useState, useEffect, Fragment } from 'react';
import { segmentTrackEvent } from '../utils';

const handleLinkClick = (e) => {
  const { target } = e;
  const targetTagName = target.tagName.toLowerCase();
  let trackableElement = target;
  let innerHTML = '';
  if ((targetTagName === 'a') || ((targetTagName === 'img') && (target.parentNode.tagName.toLowerCase() === 'a')) || this.props.dataEventName) {
    if (targetTagName === 'img') {
      trackableElement = target.parentNode;
      innerHTML = target.src.substring(target.src.lastIndexOf('/') + 1).split('?')[0];
    } else {
      ({ innerHTML } = target);
    }
  }
  const destinationUrl = trackableElement.getAttribute('href');
  const linkType = trackableElement.getAttribute('data-link-type') || 'text-link';
  const articleClickedTracker = {
    destinationUrl,
    module: 'section',
    category: linkType,
    linkType,
    label: `${innerHTML} hyperlink`,
  };
  segmentTrackEvent('article_link_clicked', articleClickedTracker);
};

const Section = ({
  section,
  sectionIndex,
  isMobile,
  pinkImage,
  num
}) => {
  const { direction, color, editor, title, added, cut, product, pinkClass } = section;
  let pinkBg = isMobile ? pinkImage.mobile : pinkImage.desktop;

  const productButtonTracker = {
    destinationUrl: product.url,
    module: 'section',
    category: 'data-link-type',
    linkType: 'data-link-type',
    label: product.name,
  };

  return (
    <Fragment>
      { pinkClass && <img className={pinkClass} src={pinkBg}/> }
      <div id="section" className={`section ${direction} section-${num}`}>
        <div className="section-text-container">
            <div className={`editor-wrapper ${direction}`}>
              <h3 className="editor" dangerouslySetInnerHTML={{ __html: editor }}/>
              <h4 className="title">{title}</h4>
            </div>
            <div className={`section-text-wrapper ${color}`}>
              <h3 className="section-subhed">wish we added:</h3>
              <div className="section-text" dangerouslySetInnerHTML={{ __html: added }} onClick={e => handleLinkClick(e)}/>
              <h3 className="section-subhed">wish we cut:</h3>
              <div className="section-text" dangerouslySetInnerHTML={{ __html: cut }} onClick={e => handleLinkClick(e)}/>
            </div>
        </div>
        <div className={`section-product ${direction}`}>
          <a href={product.url} target="_blank" onClick={() => { segmentTrackEvent('product_clicked', productButtonTracker); }}>
            <img className="product-image" src={product.image} />
            <h3 className="product-name">{product.name}</h3>
          </a>
          <a href={product.url} className="product-cta" target="_blank" onClick={() => { segmentTrackEvent('product_clicked_cta', productButtonTracker); }}>{product.cta}</a>
        </div>
      </div>
    </Fragment>
  );
};

export default Section;
